import React from "react";
import BarraVentas from "../reports/BarraVentas";
const Almacen = () => {
  return (
    <div>
      <BarraVentas />
    </div>
  );
};

export default Almacen;
